/**
 * Maps referral source domains to campaign values.
 * When a lead is created or updated with a source URL/domain matching a key,
 * the campaign field is auto-set IF campaign is not already set.
 * Add new entries here to extend the mapping.
 */
export const DOMAIN_CAMPAIGN_MAP: Record<string, string> = {
  'mysolarclaims.com': 'solar',
};

/**
 * Given a referral source string (URL or domain), returns the matching
 * campaign value, or null if no mapping exists.
 */
export function campaignFromSource(source: string | null | undefined): string | null {
  if (!source) return null;
  const lower = source.toLowerCase();
  for (const [domain, campaign] of Object.entries(DOMAIN_CAMPAIGN_MAP)) {
    if (lower.includes(domain)) return campaign;
  }
  return null;
}
